<template>
  <b-container fluid class="my-2">
    <b-row>
      <b-col cols="12" md="12" lg="12" class="mx-auto">
        <b-card title="Consentimiento Informado">
          <div class="my-1">
            <b-row>
              <b-col cols="6">
                <label for="datepicker-full-width">Escoja la fecha:</label>
                <b-form-datepicker
                  id="datepicker-full-width"
                  v-model="fechahoy"
                  menu-class="w-100"
                  calendar-width="100%"
                  class="mb-2"
                  placeholder= "No ha seleccionado la fecha"
                ></b-form-datepicker>
              
              </b-col>

              <b-col cols="6">
                <label for="hour-full-width">Escoja la hora:</label>

                <b-form-timepicker
                  v-model="horahoy"
                  now-button
                  label-now-button = "Hora actual"
                  placeholder= "No ha seleccionado la hora"

                  locale="en"
                  
                ></b-form-timepicker>
                
              </b-col>
            </b-row>
          </div>

          <!-- <div class="my-1">
            <b-form-group
              label="Consentimiento para:"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio
                v-model="consentimientopara"
                :aria-describedby="ariaDescribedby"
                name="consentimientopara"
                value="Endodoncia"
              >
                Endodoncia
              </b-form-radio>
              <b-form-radio
                v-model="consentimientopara"
                :aria-describedby="ariaDescribedby"
                name="consentimientopara"
                value="Cirugia"
                >Cirugia</b-form-radio
              >
              <b-form-radio
                v-model="consentimientopara"
                :aria-describedby="ariaDescribedby"
                name="consentimientopara"
                value="Otro"
                >Otro</b-form-radio
              >
              <b-form-group
                class="my-1"
                label="Describa otro:"
                v-if="consentimientopara === 'Otro'"
              >
                <b-form-input
                  label="Describa otro:"
                  v-model="consentimientoparaotro"
                >
                </b-form-input>
              </b-form-group>
            </b-form-group>
          </div> -->

          <!-- <div class="my-1">
            <b-row>
              <b-col md="8">
                <label for="imagenologo">Diagnosticos:</label>
                <v-select
                  placeholder="Escriba un diagnóstico..."
                  v-model="diagnosticosearch"
                  :options="opsDiagnosticos"
                  label="text"
                  @search="onSearchDiagnosticos"
                  :loading="isLoading"
                  :debounce="300"
                >
                  <template #no-options>
                    {{ noDiagnosticosMessage() }}
                  </template>
                </v-select>
              </b-col>
              <b-col md="2">
                <span><strong>Principal</strong></span>
                <b-form-checkbox v-model="esPrincipal" switch></b-form-checkbox>
              </b-col>
              <b-col md="2" class="d-flex align-items-center">
                <b-button
                  variant="info"
                  size="sm"
                  @click="agregarDiagnostico()"
                  style="cursor: pointer"
                >
                  <strong
                    ><i
                      class="fas fa-solid fa-plus"
                      style="margin-right: 10px"
                      title="Agregar Diagnóstico"
                    ></i
                  ></strong>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span Style="color:black"
                  ><strong>Tabla de Diagnósticos</strong></span
                >
                <b-table
                  v-if="diagnosticos.length > 0"
                  :items="diagnosticos"
                  :fields="fieldsti"
                >
                  <template #cell(diagnostico)="data">{{
                    data.item.diagnostico
                  }}</template>
                  <template #cell(principal)="data">{{
                    data.item.principal ? "Sí" : "No"
                  }}</template>
                  <template #cell(acciones)="data">
                    <b-button
                      variant="primary"
                      size="sm"
                      @click="editDiag(data.item, data.index)"
                      style="cursor: pointer"
                    >
                      <font-awesome-icon icon="user-pen" />
                    </b-button>
                    <b-button
                      variant="danger"
                      size="sm"
                      @click="remDiag(data.index)"
                      style="cursor: pointer"
                    >
                      <font-awesome-icon icon="circle-xmark" />
                    </b-button>
                  </template>
                </b-table>
                <div v-else class="text-center">
                  <p>No se encontraron registros</p>
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="my-1">
            <b-form-group label="Procedimiento Recomendado :">
              <b-form-input
                id="procrecomendado"
                v-model="procrecomendado"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="my-1">
            <b-form-group label="¿En qué consiste? :">
              <b-form-textarea
                id="enqueconsiste"
                v-model="enqueconsiste"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="my-1">
            <b-form-group label="¿Cómo se realiza?:">
              <b-form-textarea
                id="comoserealiza"
                v-model="comoserealiza"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="my-2">
            <b-form-group
              label="Beneficios del Procedimiento:"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="beneficios"
                :options="optionbeneficios"
                :aria-describedby="ariaDescribedby"
                name="flavour-1"
              ></b-form-checkbox-group>
              <b-row class="my-1">
                <b-col cols="9">
                  <b-form-input
                    v-model="nuevoBeneficio"
                    v-if="beneficios.includes('Otro')"
                  >
                  </b-form-input>
                </b-col>
                <b-col>
                  <b-button
                    v-if="beneficios.includes('Otro')"
                    variant="info"
                    @click="agregarBeneficio"
                  >
                    <i class="fas fa-plus"></i
                  ></b-button>
                </b-col>
              </b-row>
            </b-form-group>

            <div v-if="beneficios.length">
              <b-table :items="beneficios" :fields="fieldsben">
                <template #cell(Beneficios)="data">{{ data.item }}</template>
                <template #cell(Acciones)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="remBen(data.index)"
                    style="cursor: pointer"
                  >
                    <font-awesome-icon icon="circle-xmark" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>

          
          <div class="my-2">
            <b-form-group
              label="Riesgos frecuentes (poco graves):"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                id="checkbox-group-2"
                v-model="riesgosfrec"
                :options="optionsriesgosfrec"
                :aria-describedby="ariaDescribedby"
                name="flavour-2"
              ></b-form-checkbox-group>
              <b-row class="my-1">
                <b-col cols="9">
                  <b-form-input
                    v-model="nuevoRiesgofrec"
                    v-if="riesgosfrec.includes('Otro')"
                  >
                  </b-form-input>
                </b-col>
                <b-col>
                  <b-button
                    v-if="riesgosfrec.includes('Otro')"
                    @click="agregarRiesgofrec"
                    variant="info"
                  >
                    <i class="fas fa-plus"></i
                  ></b-button>
                </b-col>
              </b-row>
            </b-form-group>

            <div v-if="riesgosfrec.length">
              <b-table :items="riesgosfrec" :fields="fieldsrf">
                <template #cell(Riesgos)="data">{{ data.item }}</template>
                <template #cell(Acciones)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="remRiesgofrec(data.index)"
                    style="cursor: pointer"
                  >
                    <font-awesome-icon icon="circle-xmark" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>

       
          <div class="my-2">
            <b-form-group
              label="Riesgos poco frecuentes (graves):"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                id="checkbox-group-3"
                v-model="riesgosgrav"
                :options="optionsriesgosgrav"
                :aria-describedby="ariaDescribedby"
                name="flavour-3"
              ></b-form-checkbox-group>
              <b-row class="my-1">
                <b-col cols="9">
                  <b-form-input
                    v-model="nuevoRiesgograv"
                    v-if="riesgosgrav.includes('Otro')"
                  >
                  </b-form-input>
                </b-col>
                <b-col>
                  <b-button
                    v-if="riesgosgrav.includes('Otro')"
                    @click="agregarRiesgograv"
                    variant="info"
                  >
                    <i class="fas fa-plus"></i
                  ></b-button>
                </b-col>
              </b-row>
            </b-form-group>

            <div v-if="riesgosgrav.length">
              <b-table :items="riesgosgrav" :fields="fieldsrg">
                <template #cell(Riesgos)="data">{{ data.item }}</template>

                <template #cell(Acciones)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="remRiesgograv(data.index)"
                    style="cursor: pointer"
                  >
                    <font-awesome-icon icon="circle-xmark" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>

          
          <div class="my-1">
            <b-form-group
              label="De existir, escriba los riesgos específicos relacionados con el paciente (edad, estado de salud, creencias, valores, etc.):"
            >
              <b-row>
                <b-col cols="9">
                  <b-form-input v-model="nuevoRiesgoesp"> </b-form-input>
                </b-col>
                <b-button @click="agregarRiesgoesp">
                  <i class="fas fa-plus"></i
                ></b-button>
              </b-row>
            </b-form-group>

            <div v-if="riesgosesp.length">
              <b-table :items="riesgosesp" :fields="fieldsre">
                <template #cell(Riesgos)="data">{{ data.item }}</template>

                <template #cell(Acciones)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="remRiesgoesp(data.index)"
                    style="cursor: pointer"
                  >
                    <font-awesome-icon icon="circle-xmark" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
         
          <div class="my-1">
            <b-form-group label="Alternativas al procedimiento:">
              <b-row>
                <b-col cols="9">
                  <b-form-input v-model="nuevaAlternativa"> </b-form-input>
                </b-col>
                <b-button @click="agregarAlternativa">
                  <i class="fas fa-plus"></i
                ></b-button>
              </b-row>
            </b-form-group>

            <div v-if="alternativas.length">
              <b-table :items="alternativas" :fields="fieldsalt">
                <template #cell(Alternativas)="data">{{ data.item }}</template>

                <template #cell(Acciones)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="remAlternativa(data.index)"
                    style="cursor: pointer"
                  >
                    <font-awesome-icon icon="circle-xmark" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>

         
          <div class="my-1">
            <b-form-group
              label="Descripción del manejo posterior al procedimiento:"
            >
              <b-row>
                <b-col cols="12">
                  <b-form-textarea v-model="manejo"> </b-form-textarea>
                </b-col>
              </b-row>
            </b-form-group>
          </div>

          <div class="my-1">
            <b-form-group
              label="Consecuencias posibles si no se realiza el procedimiento:"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                id="checkbox-group-6"
                v-model="consecuencias"
                :options="optionsconsecuencias"
                :aria-describedby="ariaDescribedby"
                name="flavour-6"
              ></b-form-checkbox-group>
              <b-row class="my-1">
                <b-col cols="9">
                  <b-form-input
                    v-model="nuevaConsecuencia"
                    v-if="consecuencias.includes('Otro')"
                  >
                  </b-form-input>
                </b-col>
                <b-col>
                  <b-button
                    v-if="consecuencias.includes('Otro')"
                    @click="agregarConsecuencia"
                    variant="info"
                  >
                    <i class="fas fa-plus"></i
                  ></b-button>
                </b-col>
              </b-row>
            </b-form-group>

            <div v-if="consecuencias.length">
              <b-table :items="consecuencias" :fields="fieldscon">
                <template #cell(Consecuencias)="data">{{ data.item }}</template>
                <template #cell(Acciones)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="remConsecuencia(data.index)"
                    style="cursor: pointer"
                  >
                    <font-awesome-icon icon="circle-xmark" />
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>

          <div class="my-3">
            <b-row>
              <b-col md="8">
                <span Style="color:black"><strong>Imagen </strong></span>
              </b-col>
            </b-row>
            <b-row>
              <b-card class="mt-2 principal">
                <div class="title mt-0 mb-1">Cargar Imagen</div>
                <div class="mainz mt-0 mb-0">
                  <crear-documento />
                </div>
              </b-card>
            </b-row>
          </div> -->

          <div class="my-3 botongenerar">
            <b-button variant="primary" @click="generar()">Generar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BProgress,
  BFormRadio,
  BFormGroup,
  BButton,
  BTable,
  BFormCheckbox,
  BFormCheckboxGroup,
  BOverlay,
  BPagination,
  BImg,
  BFormTextarea,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import CrearDocumento from "../citas/Creardocumento.vue";
import rutas from "@/assets/utils/rutas.json";
import axios from "axios";
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

import BCardCode from "@core/components/b-card-code";

export default {
  directives: {
    Ripple,
  },
  props: ["idCirugia"],
  components: {
    BFormDatepicker,
    BImg,
    BCard,
    BCardCode,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BTable,
    BOverlay,
    BPagination,
    CrearDocumento,
    BFormRadio,
    BFormCheckboxGroup,
    BFormTextarea,
    BFormTimepicker,
  },
  data() {
    return {
      value: "",
      pressGenerar: false,
      fechahoy: null,
      horahoy: null,
      enqueconsiste: "",
      comoserealiza: "",
      alternativas: [],
      nuevaAlternativa: "",
      fieldsalt: ["Alternativas", "Acciones"],
      fieldscon: ["Consecuencias", "Acciones"],
      manejo: "",
      consecuencias: [],
      optionsconsecuencias: [
        { text: "Apiñamientos", value: "Apiñamientos" },
        { text: "Infección", value: "Infección" },
        {
          text: "Maloclusión",
          value: "Maloclusión",
        },

        { text: "Dolor", value: "Dolor" },
        { text: "Pérdida ósea", value: "Pérdida ósea" },
        { text: "Otro", value: "Otro" },
      ],
      nuevaConsecuencia: "",
      riesgosesp: [],
      nuevoRiesgoesp: "",
      fieldsre: ["Riesgos", "Acciones"],
      riesgosgrav: [],
      nuevoRiesgograv: "",
      optionsriesgosgrav: [
        { text: "Shock Anafilactico", value: "Shock Anafilactico" },
        { text: "Hemorragia", value: "Hemorragia" },
        {
          text: "Fractura ósea",
          value: "Fractura ósea",
        },
        { text: "Otro", value: "Otro" },
      ],
      fieldsrg: ["Riesgos", "Acciones"],

      riesgosfrec: [],
      nuevoRiesgofrec: "",
      optionsriesgosfrec: [
        { text: "Alveolitis", value: "Alveolitis" },
        { text: "Fractura radicular", value: "Fractura radicular" },
        {
          text: "Hemorragia",
          value: "Hemorragia",
        },
        { text: "Otro", value: "Otro" },
      ],
      fieldsrf: ["Riesgos", "Acciones"],
      fieldsben: ["Beneficios", "Acciones"],
      consentimientoparaotro: null, //este valor solo se asignara cuando consentimientopara sea null o vacio
      beneficios: [], // Must be an array reference!
      nuevoBeneficio: "",
      optionbeneficios: [
        { text: "Eliminar dolor", value: "Eliminar dolor" },
        { text: "Prevenir mal oclusion", value: "Prevenir mal oclusion" },
        {
          text: "Eliminar procesos infecciosos",
          value: "Eliminar procesos infecciosos",
        },
        { text: "Otro", value: "Otro" },
      ],
      consentimientopara: null,
      estadoconsentimiento: null,
      imagenBase64: "",
      selectedCheckboxes: [],

      selected: [],
      imagencolcos: "",
      selectedCheckboxes: [],
      fecharealizacion: "",
      seRealizo: false,
      informe: "",
      conclusion: "",
      doctor: null,
      auxiliar: null,
      fechaEjecucion: "",
      realizado: null,
      hallazgos: null,
      conclusugeren: null,
      descripcionproc: null,
      procrecomendado: null,
      idC: null,
      diagnosticosearch: "",
      esPrincipal: false,
      doctores: [], // Agrega tus opciones para doctores
      auxiliares: [], // Agrega tus opciones para auxiliares
      opsDiagnosticos: [], // Agrega tus opciones para diagnósticos
      isLoading: false,
      diagnosticos: [], // Aquí almacenarás los diagnósticos agregados
      fieldsti: ["diagnostico", "principal", "acciones"], // Define los campos para la tabla
      capturedImages: [], // Aquí almacenarás las imágenes capturadas
      capturedImgs: [], //Capturar solo las url de las imagenes
      capturedImageUrl: "", // URL de la imagen capturada actualmente
      files: [], // Aquí almacenarás los archivos seleccionados
      fileuploaded: "",
      isDragging: false, // Variable para detectar si se está arrastrando un archivo
      diagnosticos: [],
      diags: [],
    };
  },

  created() {
    this.idCirugia = this.idC;
    this.debouncedGetDiagnosticos = _.debounce(this.selDiagnostico, 300);
  },

  methods: {
    onSearchDiagnosticos(search, loading) {
      if (search.length > 5) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetDiagnosticos(search);
      } else {
        this.opsDiagnosticos = [];
        this.isLoading = false;
      }
      loading(false);
    },
    agregarDiagnostico() {
      if (!this.diagnosticosearch || !this.diagnosticosearch.text) {
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, seleccione un diagnóstico antes de agregar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return; // No realiza la adición si no se ha seleccionado un diagnóstico
      } //gercaliu
      //this.diags = JSON.stringify(diagnosticos)
      const nuevoDiagId = {
        diag: this.diagnosticosearch?.value,
      };

      const nuevoDiagnostico = {
        diagnostico: this.diagnosticosearch?.text,
        principal: this.esPrincipal,
      };
      this.diagnosticos.push(nuevoDiagnostico);
      this.diags.push(nuevoDiagId);
      // Limpiar los campos después de agregar
      this.limpiarCamposDiagnostico();
      // Si estás utilizando Vuex, para actualizar el estado global
      this.$store.dispatch("addDiagnostico", nuevoDiagnostico);
    },
    noDiagnosticosMessage() {
      if (this.searchQuery.length <= 5) {
        return "Escribe más caracteres para buscar...";
      }
      if (this.isLoading) {
        return "Buscando diagnosticos...";
      }
      if (this.searchFailed) {
        return "Error al buscar diagnosticos. Intente de nuevo.";
      }
      if (this.filteredMedicamentos.length === 0 && !this.isLoading) {
        return "No se encontraron diagnosticos que coincidan con tu búsqueda";
      }
      return "Escribe para buscar diagnosticos...";
    },
    async selDiagnostico(search) {
      if (search) {
        const query = `
                query getDiagnosticos($search: String!) {
                    getDiagnosticos(search: $search) {
                        id
                        descripcion
                    }
                }
                `;
        try {
          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              search: search,
            },
          });
          this.opsDiagnosticos = response.data.data.getDiagnosticos.map(
            (item) => ({
              value: item.id,
              text: item.descripcion,
            })
          );
        } catch (error) {
          console.error("Error fetching Diagnostico", error);
        }
      } else {
        this.opsDiagnosticos = [];
      }
    },

    agregarAlternativa() {
      // Verificar si el nuevo dato no está vacío
      if (this.nuevaAlternativa.trim() !== "") {
        // Agregar el nuevo dato al arreglo
        this.alternativas.push(this.nuevaAlternativa);
        // Limpiar el input después de agregar el dato
        this.nuevaAlternativa = "";
        console.log(this.alternativas);
      }
    },
    remAlternativa(index) {
      // Verificar si el nuevo dato no está vacío
      if (index >= 0 && index < this.alternativas.length) {
        this.alternativas.splice(index, 1);
        console.log(this.alternativas); // Imprimir el arreglo actualizado en la consola
      }
    },
    agregarConsecuencia() {
      // Verificar si el nuevo dato no está vacío
      if (this.nuevaConsecuencia.trim() !== "") {
        // Agregar el nuevo dato al arreglo
        this.consecuencias.push(this.nuevaConsecuencia);
        // Limpiar el input después de agregar el dato
        this.nuevaConsecuencia = "";
        console.log(this.consecuencias);
      }
    },
    remConsecuencia(index) {
      // Verificar si el nuevo dato no está vacío
      if (index >= 0 && index < this.consecuencias.length) {
        this.consecuencias.splice(index, 1);
        console.log(this.consecuencias); // Imprimir el arreglo actualizado en la consola
      }
    },
    agregarBeneficio() {
      // Verificar si el nuevo dato no está vacío
      if (this.nuevoBeneficio.trim() !== "") {
        // Agregar el nuevo dato al arreglo
        this.beneficios.push(this.nuevoBeneficio);
        // Limpiar el input después de agregar el dato
        this.nuevoBeneficio = "";
        console.log(this.beneficios);
      }
    },
    remBen(index) {
      // Verificar si el nuevo dato no está vacío
      if (index >= 0 && index < this.beneficios.length) {
        this.beneficios.splice(index, 1);
        console.log(this.beneficios); // Imprimir el arreglo actualizado en la consola
      }
    },
    agregarRiesgoesp() {
      // Verificar si el nuevo dato no está vacío
      if (this.nuevoRiesgoesp.trim() !== "") {
        // Agregar el nuevo dato al arreglo
        this.riesgosesp.push(this.nuevoRiesgoesp);
        // Limpiar el input después de agregar el dato
        this.nuevoRiesgoesp = "";
        console.log(this.riesgosesp);
      }
    },
    remRiesgoesp(index) {
      // Verificar si el nuevo dato no está vacío
      if (index >= 0 && index < this.riesgosesp.length) {
        this.riesgosesp.splice(index, 1);
        console.log(this.riesgosesp); // Imprimir el arreglo actualizado en la consola
      }
    },
    agregarRiesgofrec() {
      // Verificar si el nuevo dato no está vacío
      if (this.nuevoRiesgofrec.trim() !== "") {
        // Agregar el nuevo dato al arreglo
        this.riesgosfrec.push(this.nuevoRiesgofrec);
        // Limpiar el input después de agregar el dato
        this.nuevoRiesgofrec = "";
        console.log(this.riesgosfrec);
      }
    },
    remRiesgofrec(index) {
      // Verificar si el nuevo dato no está vacío
      if (index >= 0 && index < this.riesgosfrec.length) {
        this.riesgosfrec.splice(index, 1);
        console.log(this.riesgosfrec); // Imprimir el arreglo actualizado en la consola
      }
    },
    agregarRiesgograv() {
      // Verificar si el nuevo dato no está vacío
      if (this.nuevoRiesgograv.trim() !== "") {
        // Agregar el nuevo dato al arreglo
        this.riesgosgrav.push(this.nuevoRiesgograv);
        // Limpiar el input después de agregar el dato
        this.nuevoRiesgograv = "";
        console.log(this.riesgosgrav);
      }
    },
    remRiesgograv(index) {
      // Verificar si el nuevo dato no está vacío
      if (index >= 0 && index < this.riesgosgrav.length) {
        this.riesgosgrav.splice(index, 1);
        console.log(this.riesgosgrav); // Imprimir el arreglo actualizado en la consola
      }
    },

    async generar() {
      const query1 = `
                        mutation MyMutation($consinfData: ConsentimientoInformadoCirugiaInput!) {
                    crearConsentimientoInformadoCirugia(consinfData: $consinfData) {
                      message
                      status
                      consentimientoCreado {
                        id
                      }
                    }
                  }
               `;

      const query2 = `
                      mutation resultadoProceso($idProceso: String!) {
                          resultadoProceso(idProceso: $idProceso) {
                            message
                            status
                              procesore {
                                  id
                                  
                              }
                          }
                      }
                  `;
      const query3 = `mutation MyMutation($id: Int!, $imgcolcoscopia: String!) {
              agregarImgColcoscopia(id: $id, imgcolcoscopia: $imgcolcoscopia) {
                procedimientoCita {
                  id
                }
              }
            }
            `;

      const idParseado = parseInt(this.idCirugia);
      const urlFile = localStorage.getItem("doccitamedica");

      const variables1 = {
        consinfData: {
          alternativas: JSON.stringify(this.alternativas),

          beneficios: JSON.stringify(this.beneficios),
          solicitudCM: this.idCirugia,
          comoserealiza: this.comoserealiza,
          consentimientopara:
            this.consentimientopara || this.consentimientoparaotro,

          duracion: "this.duracion",
          enqueconsiste: this.enqueconsiste,
          estadoconsentimiento: this.estadoconsentimiento,
          grafico: JSON.stringify(urlFile),

          manejoposterior: this.manejo,
          procrecomendado: this.procrecomendado,

          riesgosespecificos: JSON.stringify(this.riesgosesp),
          riesgosfrecuentes: JSON.stringify(this.riesgosfrec),
          riesgospocof: JSON.stringify(this.riesgosgrav),
          consecuenciassino: JSON.stringify(this.consecuencias),
        },
      };

      // const variables2 = {
      //   idProceso: this.idP,
      // };

      // const variables3 = {
      //   id: idParseado,
      //   imgcolcoscopia: this.imagenBase64,
      // };

      // console.log(variables1);
      // console.log(variables2);

      try {
        // Realizar la solicitud GraphQL utilizando axios
        const response1 = await axios.post(rutas.axios + "api", {
          query: query1,
          variables: variables1,
        });

        // const response2 = await axios.post(rutas.axios + "api", {
        //   query: query2,
        //   variables: variables2,
        // });

        // Verificar si la operación fue exitosa
        if (
          response1.data.data.crearConsentimientoInformadoCirugia.status ===
          "SUCCESS"
        ) {
          // Mostrar una alerta de éxito
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El procedimiento se generó correctamente.",
          });

          // Redirigir a otra página si es necesario
          this.$router.go({ name: "consultar_procesoclinico" });
        } else {
          // Manejar el caso de error
          this.$swal({
            title: "Error",
            text: response.data.data.crearAdmision.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        // Mostrar una alerta de error si la solicitud falla
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear la procedimiento.",
        });
      }
    },

    async uploadFileServerProc(imageUrl) {
      try {
        // Convert the data URL to a Blob object
        const blob = await fetch(imageUrl).then((res) => res.blob());

        // Create a FormData object and append the Blob as 'file'
        const formData = new FormData();
        formData.append("file", blob, "image.jpg");

        // Send the FormData to the server using axios or another HTTP library
        const response = await axios.post(
          rutas.axios + "api/upload/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.data.url) {
          this.$swal({
            title: "Imagen Cargada",
            text: "Se ha cargado la imagen al servidor",
            icon: "success",
            confirmButtonText: "Entendido",
          });
          console.log(response.data.url);
          return response.data.url; // Assuming the backend sends the URL in the "url" key of the response
        } else {
          this.$swal({
            title: "Error al cargar",
            text: "No se ha cargado la imagen",
            icon: "error",
            confirmButtonText: "Entendido",
          });
          return "";
        }
      } catch (error) {
        console.log("File upload failed:", error);
      }
    },
    deleteCurrentImage() {
      if (this.capturedImageUrl) {
        // Buscar el índice de la imagen actual en el array
        const index = this.capturedImages.findIndex(
          (image) => image === this.capturedImageUrl
        );

        // Si se encuentra la imagen, eliminarla del array
        if (index !== -1) {
          this.capturedImages.splice(index, 1);
        }

        // Eliminar la imagen actual
        this.capturedImageUrl = null;
      }
    },
    deleteImage(index) {
      this.capturedImages.splice(index, 1);
    },
    downloadImage() {
      if (this.capturedImageUrl) {
        const downloadLink = document.createElement("a");
        downloadLink.href = this.capturedImageUrl;
        downloadLink.download = "captured-photo.jpeg"; // Esto establece un nombre de archivo predeterminado
        document.body.appendChild(downloadLink); // Añadir temporalmente el enlace al cuerpo del documento
        downloadLink.click(); // Esto desencadena la descarga
        document.body.removeChild(downloadLink); // Eliminar el enlace después de la descarga
      } else {
        console.log("No captured image to download");
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    onChange() {
      this.files = [...this.$refs.file.files];
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },

    // Agrega tus otros métodos...
  },
};
</script>
